// Nutrition › Courses: « À acheter » and « Déjà acheté » (foldable) partition ONE list (planned recipes + recipes added from
// their page), so an item is never in both; local tick; « Plan modifié » when the week changed since the list was built; restes.
import { useState } from "react";
import { ChevronDown, ChevronRight, RefreshCw, Soup } from "lucide-react";
import { Checkbox } from "@ubm/ui/components/checkbox";
import { DAYS, MEALS, MEAL_LABEL } from "./nutrition-fixtures";
import { INITIAL_SIGNATURE, coursesOf, fmtAmount, nutri, planSignature, useNutri, type CourseItem } from "./nutrition-parts";

let savedOpen = false;

function Row({ item, on }: { item: CourseItem; on: boolean }) {
  const id = `ccn-c-${item.key.replace(/[^\w]/g, "-")}`;
  return <li className="ccn-course" data-on={on || undefined}>
    <Checkbox id={id} checked={on} onCheckedChange={v => {
      const bought = nutri.get().bought;
      nutri.set({ bought: v === true ? [...bought.filter(k => k !== item.key), item.key] : bought.filter(k => k !== item.key) });
      if (v === true) nutri.toast(`${item.name} : acheté`);
    }} />
    <label htmlFor={id} className="ccn-course-text"><b>{item.name}</b><small>{item.from.join(", ")}</small></label>
    <span className="ccn-course-qty">{fmtAmount(item.qty, item.unit)}</span>
  </li>;
}

export function NutritionCourses() {
  const s = useNutri();
  const [open, setOpenState] = useState(savedOpen);
  const setOpen = (v: boolean) => { savedOpen = v; setOpenState(v); };
  const items = coursesOf(s);
  const todo = items.filter(i => !s.bought.includes(i.key));
  const done = items.filter(i => s.bought.includes(i.key));
  const modified = planSignature(s.plan) !== INITIAL_SIGNATURE;
  const restes = DAYS.flatMap(d => MEALS.flatMap(m => { const e = s.plan[d.key]?.[m]; return e && "idea" in e && /reste/i.test(e.idea) ? [{ d, m, text: e.idea }] : []; }));
  const extras = Object.keys(s.extras).length;

  return <>
    <div className="ccn-dayhead ccn-dayhead--top">
      <h2 className="ccn-h2">Semaine du 12 au 18 octobre</h2>
      <span className="ccn-count">{todo.length ? `${todo.length} à acheter` : items.length ? "Tout est acheté" : ""}</span>
    </div>

    {modified && <a className="ccn-notice" href="#/nutrition?r=repas">
      <RefreshCw size={17} strokeWidth={2} aria-hidden="true" />
      <span><b>Plan modifié</b><small>Ta liste suit tes repas prévus. Voir mes repas</small></span><ChevronRight size={16} strokeWidth={2} aria-hidden="true" />
    </a>}

    {items.length === 0 ? <div className="ccn-empty"><p>Ta liste se remplit avec tes repas prévus et les recettes que tu ajoutes.</p><a className="ccn-textbtn" href="#/nutrition?r=recettes">Voir les recettes</a></div> : <>
      <section className="ccn-card" aria-labelledby="ccn-todo">
        <h3 id="ccn-todo" className="ccn-card-title">À acheter</h3>
        {todo.length ? <ul className="ccn-courses">{todo.map(i => <Row key={i.key} item={i} on={false} />)}</ul>
          : <p className="ccn-card-empty">Rien à acheter pour le moment.</p>}
        {extras > 0 && <p className="ccn-card-foot">Comprend {extras} recette{extras > 1 ? "s" : ""} ajoutée{extras > 1 ? "s" : ""} depuis Recettes.</p>}
      </section>

      {done.length > 0 && <section className="ccn-card ccn-card--fold">
        <button type="button" className="ccn-fold" aria-expanded={open} aria-controls="ccn-done" onClick={() => setOpen(!open)}>
          <span><b>Déjà acheté</b><small>{done.length} ingrédient{done.length > 1 ? "s" : ""}</small></span>
          <ChevronDown size={18} strokeWidth={2} aria-hidden="true" data-open={open || undefined} />
        </button>
        {open && <ul id="ccn-done" className="ccn-courses">{done.map(i => <Row key={i.key} item={i} on />)}</ul>}
      </section>}
    </>}

    {restes.length > 0 && <section className="ccn-card" aria-labelledby="ccn-restes">
      <h3 id="ccn-restes" className="ccn-card-title"><Soup size={16} strokeWidth={2} aria-hidden="true" /> Restes prévus</h3>
      <ul className="ccn-restes">{restes.map(x => <li key={`${x.d.key}-${x.m}`}><span>{x.d.long.split(" ")[0]![0]!.toUpperCase() + x.d.long.split(" ")[0]!.slice(1)} · {MEAL_LABEL[x.m]}</span><b>{x.text}</b></li>)}</ul>
      <p className="ccn-card-foot">Un repas de restes n'ajoute rien à la liste.</p>
    </section>}
  </>;
}
